import React from 'react';
import styled from 'styled-components/macro';
import { Heading, ParagraphExtraSmall } from 'lib/components/styles/typography';
import { theme } from 'lib/style';
import { MdAdd } from 'react-icons/md';
import { CustomerStatistics } from 'lib/context';
import { CardType, StatsCard } from '../../customers/components/StatsCard';
import { MdFileDownload } from 'react-icons/md';
import { Button } from 'react-covideo-common';
import {
  MAX_CUSTOMER_COUNT_FOR_EXPORT,
  MIN_SELECTED_CUSTOMER_ID,
} from 'lib/const/SuperAdminRole';
import { Tooltip } from 'react-covideo-common';

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 32px;
`;

const LeftHeaderWrapper = styled.div`
  display: flex;
  gap: 48px;
`;

const RightHeaderWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const StatsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

type Props = {
  statistics: CustomerStatistics;
  loading: boolean;
  customersLength: number;
  selectedCustomerId: number;
  onAddNewUser(): void;
  exportUsers(): void;
};

export const UsersHeader = ({
  statistics,
  loading,
  customersLength,
  selectedCustomerId,
  onAddNewUser,
  exportUsers,
}: Props) => {
  const disableExportButton =
    selectedCustomerId <= MIN_SELECTED_CUSTOMER_ID &&
    customersLength > MAX_CUSTOMER_COUNT_FOR_EXPORT;

  return (
    <HeaderWrapper>
      <LeftHeaderWrapper>
        <Heading color={theme.palette.gray100}>Users</Heading>
        <StatsWrapper>
          <StatsCard
            count={!loading && statistics?.active ? statistics?.active : 0}
            text={'active users'}
          />
          <StatsCard
            count={!loading && statistics?.inActive ? statistics?.inActive : 0}
            text={'inactive users'}
            cardType={CardType.SECONDARY}
          />
        </StatsWrapper>
      </LeftHeaderWrapper>
      <RightHeaderWrapper>
        {!!disableExportButton && (
          <Tooltip
            position={'bottom' as any}
            extendStyles={{
              element: {
                width: '100%',
                maxWidth: '142px',
              },
              popup: {
                padding: '10px',
                width: '300px',
              },
            }}
            popup={
              <ParagraphExtraSmall>
                Please select the customer for whom you want to export users.
              </ParagraphExtraSmall>
            }
          >
            <Button
              icon={<MdFileDownload color={theme.palette.black_1_100} />}
              onClick={exportUsers}
              text='Export Users'
              variant='secondary'
              disabled={!!disableExportButton}
            />
          </Tooltip>
        )}
        {!disableExportButton && (
          <Button
            icon={<MdFileDownload color={theme.palette.black_1_100} />}
            onClick={exportUsers}
            text='Export Users'
            variant='secondary'
            disabled={
              selectedCustomerId <= MIN_SELECTED_CUSTOMER_ID &&
              customersLength > MAX_CUSTOMER_COUNT_FOR_EXPORT
            }
          />
        )}
        <Button
          icon={<MdAdd color={theme.palette.white || '#fff'} />}
          onClick={onAddNewUser}
          text='New User'
        />
      </RightHeaderWrapper>
    </HeaderWrapper>
  );
};
